import { createPortal } from "react-dom";
import { usePhoneLaneSlot } from "./phoneLaneSlot";
import { DisabledDeskTab, DisabledPhoneCorner } from "./rail/RailEntry";
import "./rail/rail.css";

/** Why Creo cannot be used on the current page. */
export type AgentRailOffReason = "workshop" | "client" | "no-brand";

const REASONS: Record<AgentRailOffReason, string> = {
  workshop: "The Workshop has its own chat.",
  client: "Creo is for the team, not the client view.",
  "no-brand": "Select or create a brand to use Creo.",
};

/**
 * The agent rail's place in the shell when Creo cannot be used.
 *
 * The dock is never removed: a shell that drops it gains 60px of width on
 * those pages and every view shifts. This keeps the same closed strip, tinted
 * and inert, with the reason on hover.
 */
export default function AgentRailDisabled({ reason }: { reason: AgentRailOffReason }) {
  const laneSlot = usePhoneLaneSlot((s) => s.slot);
  const text = REASONS[reason];
  return (
    <>
      {laneSlot
        ? createPortal(<DisabledPhoneCorner reason={text} inLane />, laneSlot)
        : <DisabledPhoneCorner reason={text} />}
      <div className="co-agent-dock" data-open="false">
        <DisabledDeskTab reason={text} />
      </div>
    </>
  );
}
